module.exports = __webpack_public_path__ + "static/img/微信图片_20211210181825.199092e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/微信图片_20211210181825.png
// module id = 4gtM
// module chunks = 1